import React from "react";

import { BootstrapPagination } from "./style"
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";






const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50, 100];

export function Pagination(props) {
  return (
    React.createElement(BootstrapPagination, { 
      rowsPerPageOptions: PAGE_SIZE_OPTIONS,
      ...props,
      SelectProps: {
        ...props.SelectProps,
        IconComponent: (iconProps) => React.createElement(ArrowDropDown, { ...iconProps,} )
      },}
    )
  )
} 

